export default "__VITE_ASSET__BSMbfnUd__"